export default __webpack_public_path__ + "static/media/about-part-1.f57b5ff2.png";